export default "__VITE_ASSET__6de25eeb__"